import { Box } from "@mui/material";
import React from "react";
import { AlertDialog, LoadingSection, SearchFilter, TableWithPagination, UseDebounce } from "../../../components";
import { config } from "../../../config";
import { AlertContext } from "../../../contexts";
import { NetworkCall } from "../../../networkcall";
import { AlertProps, enum_types, enumSelect, LocalStorageKeys, NetWorkCallMethods } from "../../../utils";
import { loadOptionsApis } from "../../../utils/asyncPaginateLoadOptions";
import { taxitemCreateState, taxitemdataType, taxitemheading, taxitempath } from "../../../utils/clientsettings";
import { SettingSave } from "../../companyCreation/components";
import { FormGenerator } from "../components";

export const TaxGroupItem = ({ selected = {}, t = () => false }) => {

    const [open, setOpen] = React.useState(false);
    const [data, setData] = React.useState({ ...taxitemCreateState })
    const [loading, setLoading] = React.useState(true)
    const [limits, setLimit] = React.useState(10);
    const [page, setPage] = React.useState(1);
    const [searchText, setSearchText] = React.useState("");
    //debounce
    const debounce = UseDebounce();
    const [taxList, setTaxList] = React.useState({
        list: [],
        count: 0
    })
    const alert = React.useContext(AlertContext);
    const [enumValue, setEnumValue] = React.useState({
        vat_item_code_type: [],
    })
    //get taxlist
    const getTaxlist = (limit, offset, search) => {
        setLoading(true)
        const payload={
            limit: limit,
            offset: offset,
            search: search
        }
     NetworkCall(
            `${config.api_url}/queries/vat_group_item/list`,
            NetWorkCallMethods.post,
            payload,
            null,
            true,
            false
      ).then((response) => {
            setTaxList({
                list: response.data.data?.vat_group_item?.map((val) => {
                    return ({ ...val, tax_group: val?.vat_group_master?.group_name ?? "-" })
                }),
                count: response.data.data?.count[0]?.count??response?.data?.data?.count
            })
            setLoading(false)
        }).catch((err) => {
            console.log(err)
            setLoading(false)
        })
    }
    //handle pagination
    const handlePagination = (value) => {
        setPage(value);
        let offset = (value - 1) * limits;
        getTaxlist(limits, offset)
    }
    //on change limit
    const handleChangeLimit = (value) => {
        setLimit(value);
        setPage(1);
        getTaxlist(value, 0)
    }
    const onClickRow = (data) => {
        setOpen(true)
    }
    //validate
    const validateForm = () => {
        let isValid = true;
        let error = data.error;

        if (data?.tax_group?.length === 0) {
            isValid = false;
            error.tax_group = "Tax Group is Required";
        }
        if (data?.tax_item?.length === 0) {
            isValid = false;
            error.tax_item = "Tax Item is Required";
        }
        if (data?.code?.length === 0) {
            isValid = false;
            error.code = "Tax Code is Required";
        }
        if (data?.rate?.length === 0) {
            isValid = false;
            error.rate = "Tax Item Rate is Required";
        }

        setData({ ...data, error });
        return isValid;
    }
    //update data
    const updateState = (key, value) => {
        let error = data.error;
        error[key] = "";
        setData({ ...data, [key]: value, error });
    }
    //on submit form
    const onSubmit = () => {

        if (validateForm()) {
            const payload = {
                params: [
                    {
                        group_name: data?.tax_item,
                        vat_group_item_code: data?.code?.value,
                        vat_group_master_id: data?.tax_group?.value,
                        rate: parseFloat(data?.rate),
                        is_active: data?.status,
                        client: localStorage.getItem(LocalStorageKeys.clinetID)
                    }
                ]
            }
            NetworkCall(
                `${config.api_url}/queries/vat_group_item/upsert`,
                NetWorkCallMethods.post,
                payload,
                null,
                true,
                false
            ).then(rs => {
                alert.setSnack({
                    ...alert,
                    open: true,
                    severity: AlertProps.severity.success,
                    msg: t("Tax Group Item Successfully Created"),
                });
                getTaxlist(10, 0)
                setOpen(false)
            }).catch(er => {
                alert.setSnack({
                    ...alert,
                    open: true,
                    severity: AlertProps.severity.error,
                    msg: t("Some Thing Went Wrong"),
                });
            })

        } else {
            alert.setSnack({
                ...alert,
                open: true,
                severity: AlertProps.severity.error,
                msg: t("Please Fill All Mandatory Field"),
            });
        }
    }
    const manualvatGroupResponse = (array) => {
        return array?.vat_group_master
    }
    const formData = [
        {
            isActive: true,
            component: "select",
            label: t("Tax Group"),
            value: data?.tax_group,
            placeholder: t("Tax Group"),
            onChange: (value) => updateState("tax_group", value),
            error: data?.error?.tax_group,
            isRequired: true,
            isPaginate: true,
            loadOptions: (search, array, handleLoading) =>
                loadOptionsApis(
                    "queries/vat_group_master/getAll",
                    {
                        "orderByKey": "group_name",
                        "orderByValue": "asc"
                    },
                    search,
                    array,
                    handleLoading,
                    "data",
                    {},
                    manualvatGroupResponse
                )
        },
        {
            isActive: true,
            component: "text",
            label: t("Tax Item"),
            value: data?.tax_item,
            placeholder: t("Tax Item"),
            onChange: (value) => updateState("tax_item", value?.target.value),
            error: data?.error?.tax_item,
            isRequired: true
        },
        {
            isActive: true,
            component: "select",
            label: t("Tax Item Code"),
            value: data?.code,
            placeholder: t("Tax Item Code"),
            onChange: (value) => updateState("code", value),
            error: data?.error?.code,
            isRequired: true,
            options: enumValue?.vat_item_code_type
        },
        {
            isActive: true,
            component: "text",
            label: t("Rate"),
            value: data?.rate,
            placeholder: t("Rate"),
            onChange: (value) => updateState("rate", value?.target.value),
            error: data?.error?.rate,
            isRequired: true
        },
        {
            isActive: true,
            component: "check",
            label: t("Status"),
            value: data?.status,
            onChange: (value) => updateState("status", value.target.checked)
        },
        {
            isActive: true,
            component: "button",
            label: t("Submit"),
            value: data?.status,
            onClick: onSubmit
        },
    ]
    //getenum
    const getEnum = async () => {
        const result = await enumSelect([enum_types.vat_item_code_type])
        setEnumValue({
            vat_item_code_type: result?.vat_item_code_type,
        })
    }
    React.useEffect(() => {
        getEnum()
        getTaxlist(limits, 0, "")
        // eslint-disable-next-line
    }, [])
    //search in table
    const handleSearch = (e) => {
        setSearchText(e)
        debounce(() => searchTableFunction(e), 800)
    }
    //search function
    const searchTableFunction = (e) => {
        if (page > 1) {
            setPage(1);
        }
        getTaxlist(limits, 0, e)
    }
    return (
        <Box>
            <Box>
                {/*Setting Save */}
                <SettingSave
                    btn={true}
                    btnName={t("Create Tax Group Item")}
                    onSave={onClickRow}
                    title={selected?.label} subTitle={selected?.subtitle} t={t} />
                {
                    loading ?
                        <LoadingSection bottom={"45vh"} message="Fetching ..." />
                        :
                        <>
                            <Box padding="8px 12px 0px 12px" width={"330px"}>
                                <SearchFilter value={searchText} placeholder={t("Search Country")} handleChange={(value) => handleSearch(value)} />
                            </Box>
                            <Box padding="0px 12px">
                                {/*table */}
                                <TableWithPagination
                                    heading={taxitemheading(t)}
                                    rows={taxList?.list}
                                    path={taxitempath}
                                    showpagination={true}
                                    dataType={taxitemdataType}
                                    handlePagination={handlePagination}
                                    handleChangeLimit={handleChangeLimit}
                                    totalRowsCount={taxList?.count}
                                    page={page}
                                    limit={limits}
                                    height={'calc(100vh - 351px)'}
                                    view={true}
                                    edit={true}
                                    delete={true} />
                            </Box>
                        </>
                }
            </Box>
            {/*add dialog */}
            <AlertDialog
                isNormal
                header={t("Tax Group")}
                onClose={() => setOpen(false)}
                open={open}
                component={
                    <Box p={2}>
                        <FormGenerator t={t} components={formData} />
                    </Box>
                }
            />
        </Box>
    )
}